/* generated by gulpfile.js */
/*eslint camelcase: 0 */
import even from '../filters/number/even';
import float from '../filters/number/float';
import integer from '../filters/number/integer';
import negative from '../filters/number/negative';
import nonZero from '../filters/number/nonZero';
import odd from '../filters/number/odd';
import positive from '../filters/number/positive';
import prime from '../filters/number/prime';
import zero from '../filters/number/zero';
export {
  even,
  float,
  integer,
  negative,
  nonZero,
  odd,
  positive,
  prime,
  zero
};
